import type { ReactElement } from "react";
import { SWRConfig } from "swr";

type SWRProviderProps = {
	children: ReactElement;
};

type SWRConfigChildren = Parameters<typeof SWRConfig>[0]["children"];

export const SWRProvider = ({ children }: SWRProviderProps): ReactElement => {
	return (
		<SWRConfig
			value={{
				refreshInterval: 0,
				revalidateOnFocus: false,
				revalidateOnReconnect: true,
				shouldRetryOnError: true,
				errorRetryCount: 3,
				errorRetryInterval: 5000,
				dedupingInterval: 2000,
			}}
		>
			{children as unknown as SWRConfigChildren}
		</SWRConfig>
	);
};
